export default __webpack_public_path__ + "static/media/floor-16_2.35a74038.jpg";